import * as actionTypes from '../actionTypes';

export const setDar = dar => ({ type: actionTypes.dars.SET_DAR, dar });

export const setDars = dars => ({ type: actionTypes.dars.SET_DARS, dars });